export default {
    id: "44b8601e-124a-453b-983a-7ce8e4738deb",
    icon: "mdi-gesture-tap-button",
    name: "button",
    title: "Button",
    description: "An interactive button"
}